import { GroupIdType } from '../../../types/oneTrust';
import { oneTrustIsInitialized } from './isInitialized';

export const getOneTrustConsentStatus = (oneTrustGroupId: GroupIdType) => {
    if (oneTrustIsInitialized()) {
        const onetrustActiveGroups = window.OnetrustActiveGroups.split(',');
        return onetrustActiveGroups.includes(oneTrustGroupId);
    } else {
        return null;
    }
};
